import * as React from 'react';

// Components
import PickUpPage from 'components/pages/PickUpPage';

type Props = {};

class PickUpPageWrapper extends React.Component<Props> {
  onLoad = () => {};

  render() {
    return <PickUpPage asyncScriptOnLoad={this.onLoad} />;
  }
}

export default PickUpPageWrapper;



// WEBPACK FOOTER //
// ./src/components/pages/PickUpPage/PickUpPageWrapper.js